// extracted by mini-css-extract-plugin
export default {"container":"auction-print_container__uTWn9","tbd":"auction-print_tbd__+ixYp"};